export type UVinfo = {
    color: string;
    numColor: string;
    risk: string;
    subtitle: string;
    information: string;
};

export type Page = {
    name: PageNames;
    page: JSX.Element;
}

export enum PageNames {
    INDEX = 'PageUVindex',
    LOCATIONS = 'PageLocations',
    DETAILS = 'PageDetails',
    CAMPAIGN = 'PageCampaign',
    TAN = 'PageHealthyTan',
    TIPS = 'PageTips',
    SPONSORS = 'PageSponsors',
    IMPRINT = 'PageImprint',
    LANDING = 'Landingpage',
}

export type AnyJsx = any;

export type Location = {
    [key: string]: LocationInfo;
};

export type LocationInfo = {
    lat: number;
    long: number;
}

export type Sponsor = {
    name: string;
    logo: string;
    link: string;
};